import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Waveform } from "@uiball/loaders";
import "aos/dist/aos.css";
import { format } from "date-fns";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";
import api, { wsURL } from "../../../../../../api/api";
import Autocomplete from "@mui/material/Autocomplete";
import Datetime from "react-datetime";
import {
  Course_created_successfully_image,
  Course_description_inner_ai_image,
  Regenerate_course_image,
  close,
  monetize_course_upload_document,
  autorenew,
} from "../../../../../../assets/images/images";
import Calimg from "../../../../../../assets/images/calendar.png";
import LodingAnimation from "../../../../../../components/LodingAnimation/LodingAnimation";
import "../../../../../../components/LodingAnimation/LodingAnimation.css";
import OutlineFIleInput from "../../../../../../components/styledComponents/OutlineButton";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../../state/global/slice";
import { compressImage } from "../../../../../../utils/CompressImage";
import { isRequired } from "../../../../../../utils/validator";
import CropProfileImageModal from "../../CropProfileImageModal";
import FilteredTextField from "../../../../../../components/FilteredInput/FilteredTextField";
import EditSubject from "../../../../../../components/EditSubject.js/EditSubject";
import DeletePopup from "../../../../../../components/DeletePopup/Deletepopup";
import {
  updateTeacherprofileDetails,
  resetTeacherProfile,
} from "../../../../../../state/actions/updateTeacherProfileAction";
import GoogleUploadPopup from "../../../../../../components/GoogleUploadPopup/GoogleUploadPopup";
import { Tooltip } from "react-tooltip";
import {
  resetPlatformFee,
  getPlatformFee,
} from "../../../../../../state/actions/getPlatformFeeAction";
import {getFreeDomain} from "../../../../../../state/actions/getFreeDomainAction";
import restrichtion_icon from "../../../../../../assets/images/restrichtion.svg";
import "./Styles/course.css";
import UploadFiles from "./Modals/UploadFiles";
import Loader from "./Modals/Loader";
import "./CreateCourse.css";
import ClickAwayListener from "@mui/material/ClickAwayListener";


// top of CreateCourse.jsx, outside the component
const makeLinkRow = () => ({
  id:
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `link-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  value: "",
  status: "",
  error: "",
  loading: false,
  saved: false,
  locked: false,
  taskId: "",
  pollUrl: "",
  youtubeUrl: "",
  rawUrl: "",
  type: "",
});


const CreateCourse = (props) => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const globalState = useSelector((state) => state.globalState);
  const email = globalState?.email || "";

const isValidDomain =
  email.endsWith("@arcitech.ai") ||
  email.endsWith("@arcotgroup.com") ||
  email.endsWith("@webarcitech.com");


  const { platformfee } = useSelector((state) => state.platformFee ?? {});
  const freedomain  = useSelector((state)=> state.getfreeDomain.freedomain ?? []);
  const currency_symbol = useSelector(
    (state) => state?.globalState?.currency_symbol,
  );
  const updateTeacherProfile = useSelector(
    (state) => state.updateTeacherProfile,
  );
  const isTeacher = globalState.role === "Teacher";
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const [levelInputValue, setLevelInputValue] = useState("");
  const [toLevelInputValue, setToLevelInputValue] = useState("");
  const [showCoursesuccesfully, setShowCoursesuccesfully] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [createCourseLoading, setCreateCourseLoading] = useState(false);
  const [changeImageUploadText, setChangeImageUploadText] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const [addNewSubjects, setaddNewSubjects] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [uplodedImage, setUplodedImage] = useState(null);
  const [commission, setcommission] = useState();
  const [finalAmt, setfinalAmt] = useState();
  const [isDescGenerating, setIsDescGenerating] = useState(false);
  const [loadingText, setLoadingText] = useState(
    "Course creation in progress...",
  );
  const [isMonetizeEnabled, setIsMonetizeEnabled] = useState(false);
  const savedMonetizeValues = useRef({ price: "", discount_percentage: "" });
  const newCourseResponseRef = useRef(null);
  const [links, setLinks] = useState([makeLinkRow()]);

  const [courseFormState, setCourseFormState] = useState(() => {
    const savedCourseData = localStorage.getItem("courseFormState");
    try {
      const _savedCourseData = JSON.parse(savedCourseData);
      // _savedCourseData.start_date = dayjs(_savedCourseData.start_date);

      // _savedCourseData.end_date = dayjs(_savedCourseData.end_date);

      // Ensure start_date and end_date are in dayjs format if available
      if (_savedCourseData.start_date) {
        _savedCourseData.start_date = dayjs(_savedCourseData.start_date);
      }
      if (_savedCourseData.end_date) {
        _savedCourseData.end_date = dayjs(_savedCourseData.end_date);
      }
      // normalize: guarantee free_domains is always an array
if (_savedCourseData && !Array.isArray(_savedCourseData.free_domains)) {
  _savedCourseData.free_domains = [];
}

      return savedCourseData
        ? (_savedCourseData ?? {})
        : {
          name: "",
          subject: "",
          from_grade: "",
          to_grade: "",
          start_date: null,
          end_date: null,
          price: null,
          discount_percentage: "",
          description: "",
          image: "",
          image_url: "",
          image_type: "",
          teacher: globalState?.teacher_details?.data?.teacher_id,
          is_active: true,
        };
    } catch (error) {
      return {
        name: "",
        subject: "",
        from_grade: "",
        to_grade: "",
        start_date: null,
        end_date: null,
        price: null,
        discount_percentage: "",
        description: "",
        image: "",
        image_url: "",
        image_type: "",
        teacher: globalState?.teacher_details?.data?.teacher_id,
        is_active: true,
      };
    }
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    subject: "",
    from_grade: "",
    to_grade: "",
    start_date: "",
    end_date: "",
    description: "",
    image: "",
    image_url: "",
    image_type: "",
    price: "",
    discounted_price: "",
  });

  const validateCoursePrice = (value) => {
    const priceString = String(value ?? "").trim();
    const Courseprice = parseFloat(Number(priceString).toFixed(2));

    if (isNaN(Courseprice)) return "Enter a valid course price";
    if (!priceString) {
      return "This field is required";
    }

    const price = Number(priceString);

    if (Number.isNaN(price)) {
      return "Enter a valid course price";
    }

    // if (price <= 99) {
    //   return "Course price must be greater than ₹99";
    // }

    // Integer validation
    if (!Number.isInteger(price)) {
      return "Course price must be a whole number";
    }

    if (currency_symbol) {
      if (currency_symbol === "₹") {
        if (price > 100000) {
          return "Price must not be more than ₹100000";
        } else if (price < 99) {
        } else if (price < 99) {
          return "Price must be ₹99 or higher";
        }
      } else if (currency_symbol === "$") {
        if (price > 5000) {
          return "Price must not be more than $5000";
        } else if (price < 1) {
          return "Price must be $1 or higher";
        }
      }
    }

    return "";
  };

  const actualDiscountAmt =
    Number(courseFormState.price || 0) -
    (Number(courseFormState.price || 0) *
      Number(courseFormState.discount_percentage || 0)) /
    100;

  const validateDiscountedPrice = (discounted, actualDiscountAmt) => {
    const amt = Number(actualDiscountAmt || discountedAmt);

    if (!discounted || isNaN(amt)) return "";          // no value yet, skip

    if (currency_symbol === "₹" && amt < 99) {
      return "Discounted price must be ₹99 or higher";
    }
    if (currency_symbol === "$" && amt < 1) {
      return "Discounted price must be $1 or higher";
    }
    return "";
  };
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const [clickCount, setClickCount] = useState(
    Number(localStorage.getItem("clickCount")) || 0,
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [showUploadFile, setShowUploadFile] = useState(false); // state to control the visibility of the Upload file component for the course
  const subjectsKey = isTeacher ? "subject_names" : "interest_names";
  const [discountedAmt, setdiscountedAmt] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]); // Files selected wither from the google drive or uploaded from the local computer
  const [selectedRepoFiles, setSelectedRepoFiles] = useState([]); // files selected from the my files
  const discountArr = [
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
  ];

  // const dummyDomains = [
  //   "Google",
  //   "Microsoft",
  //   "Amazon",
  //   "Meta",
  // ];

  const [selectedDomains, setSelectedDomains] = useState(  () => courseFormState.free_domains ?? [],);
  const [showDropdown, setShowDropdown] = useState(false);

  const isLowerSchoolEnabled = globalState.enabled_modules?.includes("lowerSchool")

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedDomains(freedomain);
    } else {
      setSelectedDomains([]);
    }
  };

  const handleCheckboxChange = (domain) => {
    setSelectedDomains((prev) =>
      prev.includes(domain)
        ? prev.filter((item) => item !== domain)
        : [...prev, domain]
    );
  };

  const transformedDiscountArr = discountArr.map((discount) => `${discount}%`);

  const onOpenModal = () => {
    setModalIsOpen(true);
  };

  const onCloseModal = (val) => {
    setChangeImageUploadText(val);
    setModalIsOpen(false);
  };

  const isValidStartDate = (current) => {
    const today = dayjs().startOf("day"); // Today at 00:00
    return current.isSameOrAfter(today); // Allow today and future dates
  };

  const isValidEndDate = (current) => {
    // Ensure there's a start date selected
    if (!courseFormState.start_date) {
      return false; // Disable all dates if no start date is selected
    }

    // Calculate the minimum end date as one day after the start date
    const minEndDate = dayjs(courseFormState.start_date).add(1, "day");

    // Compare the current date being processed by the picker with the minimum end date
    // Convert 'current' to a dayjs object for comparison
    return dayjs(current).isAfter(minEndDate, "day"); // 'isAfter' will ensure the date is at least the day after minEndDate
  };

  const setShowCourse = props.setShowCourse;
  const toggleCourse = props.toggleCourse;
  // Function to fetch teacher_id
  const fetchTeacherId = async () => {
    if (courseFormState.teacher === undefined || !courseFormState.teacher) {
      // Check if teacher_id is empty or undefined
      try {
        const res = await api.get("/auth/get-teacher/", {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        });
        if (res?.data?.status === 200) {
          // Set teacher_id in courseFormState
          updateState("teacher_details", res?.data ?? {});
          setCourseFormState((prev) => ({
            ...prev,
            teacher: res?.data?.data?.teacher_id,
          }));
          return true; // Successfully fetched teacher_id
        }
      } catch (error) {
        console.error("Failed to fetch teacher_id:", error);
      }
    } else {
      return true; // teacher_id is already available
    }
    return false; // Failed to fetch teacher_id
  };
  const createCourse = async (skipForNow = false) => {
    try {
      if (courseFormState.start_date) {
        courseFormState.start_date = dayjs(
          new Date(courseFormState?.start_date),
        ).format("YYYY-MM-DD");
      }

      if (
        courseFormState.end_date &&
        dayjs(courseFormState.end_date).isValid()
      ) {
        courseFormState.end_date = dayjs(
          new Date(courseFormState.end_date),
        ).format("YYYY-MM-DD");
      } else {
        courseFormState.end_date = "";
      }

      const youtubeUrls = links
        .filter((r) => r.saved && (r.youtubeUrl || r.rawUrl))
        .map((r) => r.youtubeUrl || r.rawUrl);

      const formData = new FormData();
      formData.append("name", courseFormState.name);
      formData.append("subject", courseFormState.subject);
      formData.append("from_grade", courseFormState.from_grade);
      formData.append("to_grade", courseFormState.to_grade);
      formData.append("start_date", courseFormState.start_date);
      formData.append("end_date", courseFormState.end_date);
      formData.append("description", courseFormState.description);
      formData.append("image_type", courseFormState.image_type);
      formData.append("image", courseFormState.image_type === 2 ? courseFormState.image : "");
      formData.append("image_url", courseFormState.image_type === 1 ? courseFormState.image_url : "");
      formData.append("teacher", courseFormState.teacher);
      formData.append("is_active", courseFormState.is_active);
      if (youtubeUrls.length > 0) {
        youtubeUrls.forEach((url) => {
          formData.append("youtube_urls", url);
        });
      }
      if (isMonetizeEnabled) {
        formData.append("price", courseFormState.price);
        formData.append("discount_percentage", courseFormState.discount_percentage);
        formData.append("discounted_price", discountedAmt);
        formData.append("is_monetized", true);
        formData.append("free_domains", JSON.stringify(selectedDomains));
      }


      const payloadWithoutMonetization = {
        name: courseFormState.name,
        subject: courseFormState.subject,
        from_grade: courseFormState.from_grade,
        to_grade: courseFormState.to_grade,
        start_date: courseFormState.start_date,
        end_date: courseFormState.end_date,
        description: courseFormState.description,
        image: courseFormState.image_type === 2 ? courseFormState.image : "",
        image_url:
          courseFormState.image_type === 1 ? courseFormState.image_url : "",
        image_type: courseFormState.image_type,
        teacher: courseFormState.teacher,
        is_active: courseFormState.is_active,
        ...(youtubeUrls.length > 0 && { youtube_urls: youtubeUrls }),
      };

      const payloadWithMonetization = {
        ...payloadWithoutMonetization,
        price: courseFormState.price,
        discount_percentage: courseFormState.discount_percentage,
        discounted_price: discountedAmt,
        is_monetized: true,
      };
      setCreateCourseLoading(true);
      const response = await api.post(
        "/courses/create-course/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        },
      );
      if (response.status === 200 || response.status === 201) {
        localStorage.removeItem("courseFormState");
        localStorage.removeItem("to_grade");
        localStorage.removeItem("from_grade");
        setShowCoursesuccesfully(true);
        setCreateLoading(false);
        setCreateCourseLoading(false);
        newCourseResponseRef.current = response.data?.data ?? {};

        // add timeout
        document.body.style.overflow = "auto";
        setTimeout(() => {
          setShowCoursesuccesfully(false);
          if (skipForNow) {
            setShowCourse(false);
            const course = response.data?.data ?? {};
            navigate(`/course/${course.course_id}/view`, {
              state: {
                course,
                teacher_id: globalState?.teacher_details?.data?.teacher_id,
              },
            });
            document.body.style.overflow = "auto";
            return course;
          }
        }, 2000);
      } else {
        toast.error("Failed to create course.", {
          position: "top-center",
        });
        setCreateLoading(false);
        setCreateCourseLoading(false);
      }
      console.log("course created response", response);
      return response;
    } catch (error) {
      console.error("API Error:", error);

      toast.error("Failed to create course.", {
        position: "top-center",
      });

      setCreateLoading(false);
      setCreateCourseLoading(false);
    }
  };
  // Fetch teacher_id on page load

  useEffect(() => {
  setCourseFormState((prev) => ({ ...prev, free_domains: selectedDomains }));
}, [selectedDomains]);
  useEffect(() => {
    fetchTeacherId();
  }, []); // Empty dependency array means this useEffect runs once when component mounts

  useEffect(() => {
    localStorage.setItem("courseFormState", JSON.stringify(courseFormState));
    localStorage.setItem("monetizeEnable", JSON.stringify(isMonetizeEnabled));
  }, [courseFormState, isMonetizeEnabled]);

  useEffect(() => {
    localStorage.setItem("clickCount", clickCount);
  }, [clickCount]);

  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const storedGrade = localStorage.getItem("from_grade");
    if (storedGrade) {
      const grade = gradeArray.find((option) => option.key === storedGrade);
      if (grade) {
        setCourseFormState({ ...courseFormState, from_grade: storedGrade });
        setLevelInputValue(grade.value); // Set Autocomplete input value
      }
    }
  }, []);

  useEffect(() => {
    // Store from_grade value in local storage whenever it changes
    localStorage.setItem("from_grade", courseFormState.from_grade);
  }, [courseFormState.from_grade]); // Dependency ensures this effect runs whenever from_grade changes

  useEffect(() => {
    // Retrieve to_grade value from local storage on component mount
    const storedToGrade = localStorage.getItem("to_grade");
    if (storedToGrade) {
      const grade = gradeArray.find((option) => option.key === storedToGrade);
      if (grade) {
        setCourseFormState({ ...courseFormState, to_grade: storedToGrade });
        setToLevelInputValue(grade.value); // Set Autocomplete input value
      }
    }
  }, []);

  useEffect(() => {
    // Store to_grade value in local storage whenever it changes
    localStorage.setItem("to_grade", courseFormState.to_grade);
  }, [courseFormState.to_grade]); // Dependency ensures this effect runs whenever to_grade changes

  // Handle input change for form fields
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let error = "";

    const validCourseNameRegex = /^[a-zA-Z0-9- ]*$/; // Regular expression for letters, numbers, and hyphens

    if (name === "name") {
      error = isRequired(value);

      if (/[+%&#]/.test(value)) {
        error = "Characters + % & # are not allowed";
      }

      setFormErrors((prev) => ({ ...prev, [name]: error }));
      setCourseFormState((prev) => ({ ...prev, [name]: value })); // keep raw value so user sees what they typed
      return;

      // Validate course name against the regex
      // if (!validCourseNameRegex.test(value)) {
      //   error = "Course name should only contain letters, numbers and hyphen.";
      // }
    } else if (name === "description") {
      error = isRequired(value);
    } else if (name === "from_grade") {
      error = isRequired(value);
    } else if (name === "to_grade") {
      error = isRequired(value);
    } else if (name === "subject") {
      error = isRequired(value);
    } else if (name === "start_date") {
      error = isRequired(value);
    } else if (name === "end_date") {
      error = isRequired(value);
    } else if (name === "price" && isMonetizeEnabled) {
      error = validateCoursePrice(value);
    }
    setFormErrors({
      ...formErrors,
      [name]: error,
    });

    setCourseFormState((prev) => ({ ...prev, [name]: value }));
  };
  const YYYYMMDD = (date) => {
    try {
      return format(new Date(date ?? ""), "yyyy-MM-dd");
    } catch (error) {
      return "";
    }
  };

  const handleInputChangedate = (name, value) => {
    let error = "";
    if (name === "start_date") {
      error = isRequired(YYYYMMDD(value));
    } else if (name === "end_date") {
      error = isRequired(YYYYMMDD(value));
    }
    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    if (YYYYMMDD(value)) {
      setCourseFormState((prev) => ({
        ...prev,
        [name]: YYYYMMDD(value),
      }));
    }
  };

  // Handle file input
  const handleFileInput = async (event) => {
    setCourseFormState((prev) => ({ ...prev, image_type: "" }));
    // Show loader when file input is created
    setImageUploading(true);
    setSelectedImage(null);
    setImageUploaded(false);

    const file = event.target.files[0];
    if (file) {
      try {
        // Compress the image
        const compressedImage = await compressImage(file);

        setSelectedImage(URL.createObjectURL(compressedImage));
        onOpenModal();
        setFormErrors({
          ...formErrors,
          image: "",
          image_url: "",
        });

        setCourseFormState((prev) => ({ ...prev, image_type: 2 }));
      } catch (error) {
        console.error("Image compression failed:", error);
        setSelectedImage(null);
        // Handle error and set form error
        setFormErrors({
          ...formErrors,
          image: "Image compression failed.",
        });
      } finally {
        // Hide loader when compression is complete
        setImageUploading(false);
      }
    } else {
      setSelectedImage(null);
      // Hide loader when no file is selected (cancel)
      setImageUploading(false);
    }
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [tempFormData, setTempFormData] = useState(null);
  const handleCancelClick = () => {
    setOpenDialog(true);
  };
  const cancelRegistration = () => {
    setOpenDialog(false);
    document.body.style.overflow = "auto";
    // Reset the selected role or handle cancellation
  };

  const resetEndDate = () => {
    setCourseFormState((prev) => ({
      ...prev,
      end_date: null, // Reset to null or empty string depending on how your state is expected
    }));
  };

  const confirmCancellation = () => {
    setOpenDialog(false);
    document.body.style.overflow = "auto";
    localStorage.removeItem("courseFormState");
    localStorage.removeItem("to_grade");
    localStorage.removeItem("from_grade");
    localStorage.removeItem("clickCount");
    localStorage.removeItem("monetizeEnable");
    props.toggleCourse("auto");

    // navigate to a different page or perform other cleanup actions
  };

  useEffect(() => {
    if (openDialog) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    };
  }, [openDialog]);


  //og code 
  // useEffect(() => {
  //   if (globalState.enabled_modules?.includes("marketplace")) {
  //     let discountAmt =
  //       courseFormState.price -
  //       (courseFormState.price * courseFormState.discount_percentage) / 100;
  //     setdiscountedAmt(discountAmt.toFixed(2));
  //     let commissionVal = (discountAmt * platformfee) / 100;
  //     setcommission(commissionVal.toFixed(2));
  //     let amountAfterComm = discountAmt - (discountAmt * platformfee) / 100;
  //     setfinalAmt(amountAfterComm.toFixed(2));
  //   }
  // }, [courseFormState.price, courseFormState.discount_percentage, platformfee]);


  //new round off logic
  const [roundOffValue, setRoundOffValue] = useState(0);

  useEffect(() => {
    if (globalState.enabled_modules?.includes("marketplace")) {
      const price = Number(courseFormState.price || 0);
      const discountPercentage = Number(courseFormState.discount_percentage || 0);

      // Original discounted amount
      let discountAmt = price - (price * discountPercentage) / 100;

      let finalDiscountAmt = discountAmt;
      let roundOff = 0;

      // Apply round-off ONLY for USD
      // if (currency_symbol === "$") {
        finalDiscountAmt = Math.round(discountAmt);
        roundOff = finalDiscountAmt - discountAmt;
      // }

      // setdiscountedAmt(finalDiscountAmt.toFixed(2));
      setdiscountedAmt(finalDiscountAmt);

      setRoundOffValue(roundOff.toFixed(2));

      const commissionVal = (finalDiscountAmt * platformfee) / 100;
      setcommission(commissionVal.toFixed(2));

      const amountAfterComm = finalDiscountAmt - commissionVal;
      setfinalAmt(amountAfterComm.toFixed(2));
    }
  }, [
    courseFormState.price,
    courseFormState.discount_percentage,
    platformfee,
    currency_symbol,
  ]);


  useEffect(() => {
    if (globalState.enabled_modules?.includes("marketplace")) {
      const savedMonetize = localStorage.getItem("monetizeEnable");
      if (savedMonetize) {
        setIsMonetizeEnabled(JSON.parse(savedMonetize));
      }
    }
  }, []);

  useEffect(() => {
    if (globalState.enabled_modules?.includes("marketplace")) {
      dispatch(getPlatformFee(token));
      dispatch(getFreeDomain(token));
    }
  }, []);

  // Declare socket using the useState hook
  const [getSocket, setSocket] = useState(null);
  const [isRegenerate, setIsRegenerate] = useState(false);
  const generatesImges = async () => {
    setChangeImageUploadText(false);
    if (clickCount >= 3) {
      setErrorMessage(
        "The AI image generation has reached its three-attempt limit.",
      );
      return;
    }
    setImageUploaded(false);
    setIsRegenerate(true);
    setSelectedImage(null);
    const formdata = {
      Course_name: courseFormState.name || "",
      Subject:
        subjectsArray.filter((grd) => grd.key === courseFormState.subject)[0]
          ?.value ?? "",
      Grade: `${
        gradeArray.filter((grd) => grd.key === courseFormState.from_grade)[0]
        ?.value ?? ""
        }-${
          gradeArray.filter((grd) => grd.key === courseFormState.to_grade)[0]
          ?.value ?? ""
        }`,
      Course_description: courseFormState.description || "",
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        // Add any other headers that are required and were present in the Postman request
      },
      timeout: 100000,
      // Add other Axios configurations as necessary
    };

    await api
      .post(`/ai/generate_course_image/`, formdata, config)
      .then((response) => {
        setImageUploaded(true);
        setSelectedImage(response.data.image_urls);
        setUplodedImage(response.data.image_urls);
        setCourseFormState((prev) => ({
          ...prev,
          image_url: response.data.image_urls,
          image: null,
        }));
        setClickCount(clickCount + 1);
        setCourseFormState((prev) => ({ ...prev, image_type: 1 }));
        setIsRegenerate(false);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          image: "",
          image_url: "",
        }));
      })
      .catch((error) => {
        setFormErrors({
          ...formErrors,
          image_url: "Couldn't generate image",
        });
        setCourseFormState((prev) => ({ ...prev, image_type: 1 }));
        setSelectedImage(null);
        setIsRegenerate(false);
      });
    setIsRegenerate(false);
  };
  // New WebSocket URL
  const timestamp = Date.now();

  const newWebSocketURL = `${wsURL}ws/course_descrption/${timestamp}/?token=${token}`;

  let combinedMessage = []; // ✅ Buffer to hold incoming messages

  // Create the WebSocket connection when the component mounts
  useEffect(() => {
    const socket = new WebSocket(newWebSocketURL);
    setSocket(socket);

    // Event handler for when the WebSocket connection is established
    socket.addEventListener("open", (event) => { });
    document.body.style.overflow = "auto !important";

    // Event handler for incoming messages from the WebSocket server
    socket.addEventListener("message", (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data && data.message) {
          const message = data.message;

          // ✅ Clear old messages when a new response starts
          if (message.includes("<STARTOFTURN>")) {
            combinedMessage.length = 0; // Reset buffer here
            setLoading(true); // Start loader for new data
          }

          combinedMessage.push(message);
          const rawCombined = combinedMessage.join(""); // capture BEFORE stripping tags

          // ✅ Remove STARTOFTURN and ENDOFTURN tags
          let chatdatares = rawCombined
            .replace(/<STARTOFTURN>/g, "")
            .replace(/<ENDOFTURN>/g, "");

          // ✅ Stop loader when actual data is received
          if (chatdatares.trim() !== "") {
            setLoading(false);
          }

          // ✅ Stream finished — reset buffer and re-enable upload button
          if (rawCombined.includes("<ENDOFTURN>")) {
            setIsDescGenerating(false);
            combinedMessage.length = 0; // Clear buffer here
            combinedMessage.push(chatdatares);
          }

          setCourseFormState((prev) => ({
            ...prev,
            description: chatdatares,
          }));

          setFormErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        } else {
          setLoading(false);
          setIsDescGenerating(false);
        }
      } catch (error) {
        setLoading(false);
        setIsDescGenerating(false);
      }
    });

    // ✅ Backstops so the flag can't get stuck if the stream drops without <ENDOFTURN>
    socket.addEventListener("close", (event) => {
      setIsDescGenerating(false);
    });
    socket.addEventListener("error", (error) => {
      setIsDescGenerating(false);
    });

    return () => {
      if (socket.readyState === 1) {
        socket.close();
      }
    };
  }, []);

  let grade_details;
  try {
    grade_details = globalState.grade_details?.grade;
  } catch (error) { }

  const gradeArray =
    grade_details && grade_details
      ? Object.entries(grade_details).map(([key, value]) => ({ key, value }))
      : [];

  const teacherSubjects = globalState?.teacher_details?.data?.subjects;

  const subjectsArray = teacherSubjects
    ? Object.entries(teacherSubjects)
      .map(([key, value]) => ({ key, value }))
      .sort((a, b) => a.value.localeCompare(b.value))
    : [];

  subjectsArray.push({ key: "others", value: "Others" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    errors.name = isRequired(courseFormState.name);
    errors.name =
      courseFormState.name.trim() === "" && "This field is required";
    if (/[+%&#]/.test(courseFormState.name)) {
      errors.name = "Characters + % & # are not allowed";
    }
    errors.subject = isRequired(courseFormState.subject);
    errors.to_grade = isRequired(courseFormState.to_grade);
    errors.from_grade = isRequired(courseFormState.from_grade);
    // Guard against stale/restored state where Level ends up above To Level
    if (
      !errors.from_grade &&
      !errors.to_grade &&
      Number(courseFormState.from_grade) > Number(courseFormState.to_grade)
    ) {
      errors.from_grade = "Level cannot be higher than To Level";
    }
    errors.start_date = isRequired(courseFormState.start_date);
    errors.price = isMonetizeEnabled
      ? validateCoursePrice(courseFormState.price)
      : "";
    errors.discounted_price = isMonetizeEnabled   // ← add this
      ? validateDiscountedPrice(discountedAmt, actualDiscountAmt)
      : "";
    errors.description = isRequired(courseFormState.description);
    errors.description =
      courseFormState.description.trim() === "" && "This field is required";
    if (courseFormState.image_type === 1) {
      errors.image_url = isRequired(courseFormState.image_url);
    } else {
      errors.image = isRequired(courseFormState.image);
    }

    setFormErrors(errors);

    if (!Object.values(errors).some((error) => error)) {
      setCreateLoading(true);
      toast.dismiss();
      const isTeacherIdAvailable = await fetchTeacherId();
      if (isTeacherIdAvailable) {
        localStorage.removeItem("clickCount");
        if(isLowerSchoolEnabled && +courseFormState?.to_grade <= 5){
        createCourse(true);
        } else{
          openUploadFile();
        }
      } else {
        toast.error("Failed to get teacher details.", {
          position: "top-center",
        });
        setCreateLoading(false);
      }
    }
  };

  function EnhancedDescription({
    courseName,
    subject,
    from_grade,
    to_grade,
    keywords,
  }) {
    // Function to enhance the description  using the WebSocket connection

    const enhanceDescription = (e) => {
      e.preventDefault();
      setLoading(true);
      setIsDescGenerating(true);

      if (getSocket) {
        const payload = {
          course_name: courseName,
          subject:
            subjectsArray.filter((sub) => sub.key === subject)[0]?.value ?? "",
          start_grade:
            gradeArray.filter((grd) => grd.key === from_grade)[0]?.value ?? "",
          end_grade:
            gradeArray.filter((grd) => grd.key === to_grade)[0]?.value ?? "",
          keywords: keywords,
          user_prompt: keywords,
        };
        const payloadJSON = JSON.stringify(payload);

        getSocket.send(payloadJSON);
      }
    };

    return (
      <button
        type="button"
        onClick={enhanceDescription}
        disabled={
          !courseFormState.name ||
          !courseFormState.subject ||
          !courseFormState.from_grade ||
          !courseFormState.to_grade ||
          !courseFormState.start_date
        }
        className="Course-description-inner-ai-feilds"
      >
        <div className="Course-description-inne r-ai-image">
          <img src={Course_description_inner_ai_image} alt="" />
        </div>
        <span>Enhance Course Description</span>
      </button>
    );
  }
  const [open1, setopen1] = useState(false);
  const [open2, setopen2] = useState(false);
  function capitalizeFirstLetter(string) {
    return string.replace(/\b(\w)/g, (s) => s.toUpperCase());
  }
  const capitalizedOptions = subjectsArray.map((option) => ({
    ...option,
    value: capitalizeFirstLetter(option.value),
  }));

  const [isAddToSubjetModelOpen, setIsAddToSubjetModelOpen] = useState(false);

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

  const handleClose = () => {
    setIsDeletePopupOpen(false);
  };

  const handleAddSubjects = () => {
    handleClose();
    const req = {
      subject_names: addNewSubjects,
    };
    dispatch(updateTeacherprofileDetails(req, token));
  };

  useEffect(() => {
    if (courseFormState.subject === "others") {
      setIsAddToSubjetModelOpen(true);
    }
  }, [courseFormState.subject]);

  useEffect(() => {
    if (updateTeacherProfile.profileDetails !== null) {
      updateState("teacher_details", updateTeacherProfile.profileDetails ?? {});
      toast.success("Subject Updated Successfully.", {
        position: "top-center",
      });
      dispatch(resetTeacherProfile());
    }
  }, [updateTeacherProfile]);

  // const [isShowGoogleUploadPopup, setIsShowGoogleUploadPopup] = useState(false);
  // const openFileuploadPopup = () => {
  //   setIsShowGoogleUploadPopup(true);
  // };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(e);
    }
    //     if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
    //   e.preventDefault();
    // }
  };

  // Function to clear validation errors for Autocomplete fields
  const clearValidationError = (fieldName) => {
    setFormErrors((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };

  // useEffect to clear validation errors when form values change
  useEffect(() => {
    if (courseFormState.subject && formErrors.subject) {
      clearValidationError("subject");
    }
  }, [courseFormState.subject]);

  useEffect(() => {
    if (courseFormState.from_grade && formErrors.from_grade) {
      clearValidationError("from_grade");
    }
  }, [courseFormState.from_grade]);

  useEffect(() => {
    if (courseFormState.to_grade && formErrors.to_grade) {
      clearValidationError("to_grade");
    }
  }, [courseFormState.to_grade]);

  const openUploadFile = () => {
    setShowUploadFile(true);
  };

  //og code
  // const handleSwitchToggle = () => {
  //   setIsMonetizeEnabled((prev) => {
  //     const nextValue = !prev;

  //     if (!nextValue) {
  //       setFormErrors((prevErrors) => ({
  //         ...prevErrors,
  //         price: "",
  //         discount_percentage: "",
  //       }));

  //       setCourseFormState((prevState) => ({
  //         ...prevState,
  //         price: null,
  //         discount_percentage: null,
  //       }));

  //       setdiscountedAmt("");
  //       setcommission("");
  //       setfinalAmt("");
  //     }

  //     return nextValue;
  //   });
  // };

  //shubhangi code
  const handleSwitchToggle = () => {
    const newState = !isMonetizeEnabled;
    setIsMonetizeEnabled(newState);

    if (!newState) {
      // Save BEFORE clearing
      savedMonetizeValues.current = {
        price: courseFormState.price,
        discount_percentage: courseFormState.discount_percentage,
      };
      setCourseFormState((prev) => ({
        ...prev,
        price: null,
        discount_percentage: null,
      }));
      setFormErrors((prev) => ({
        ...prev,
        price: "",
        discount_percentage: "",
        discounted_price: "",
      }));
      setdiscountedAmt("");
      setcommission("");
      setfinalAmt("");
    } else {
      // Restore saved values when toggling back ON
      setCourseFormState((prev) => ({
        ...prev,
        price: savedMonetizeValues.current.price,
        discount_percentage: savedMonetizeValues.current.discount_percentage,
      }));
    }
  };
  const hasBlockingErrors = Object.entries(formErrors).some(([key, error]) => {
    if (
      !isMonetizeEnabled &&
      ["price", "discount_percentage", "discounted_price"].includes(key)
    ) {
      return false;
    }

    return Boolean(error);
  });

  const gotToStepOne = () => {
    setCreateLoading(false);
    setShowUploadFile(false);
  };

  const closeModal = () => {
    const courseData = newCourseResponseRef.current;
    document.body.style.overflow = "auto";
    setShowCourse?.(false);

    if (!courseData?.course_id) {
      return;
    }

    navigate(`/course/${courseData.course_id}/view`, {
      state: {
        course: courseData,
        teacher_id: globalState?.teacher_details?.data?.teacher_id,
      },
    });
  };

  // useEffect(() => {
  //   if (isMonetizeEnabled && discountedAmt) {
  //     setFormErrors((prev) => ({
  //       ...prev,
  //       discounted_price: validateDiscountedPrice(discountedAmt,actualDiscountAmt),
  //     }));
  //   }
  // }, [discountedAmt, actualDiscountAmt, isMonetizeEnabled]);

  useEffect(() => {
    if (isMonetizeEnabled) {
      const amountToValidate =
        actualDiscountAmt !== undefined &&
          actualDiscountAmt !== null &&
          actualDiscountAmt !== ""
          ? actualDiscountAmt
          : discountedAmt;

      setFormErrors((prev) => ({
        ...prev,
        discounted_price: validateDiscountedPrice(amountToValidate),
      }));
    }
  }, [discountedAmt, actualDiscountAmt, isMonetizeEnabled]);




  const isDiscountDisabled =
    currency_symbol === "$" && Number(courseFormState.price) === 1;
  return (
    <>
      <form
        action=""
        className="Create-Courses-section"
        onSubmit={handleSubmit}
        onKeyDown={handleKeyDown}
      >
        <div
          // className={`Create-Courses-wrapper ${showUploadFile ? "!w-[90%] lg:!w-[70%] " : ""}`}
          className={`Create-Courses-wrapper ${showUploadFile ? "!w-[70%]  max-[1293px]:!w-[90%]" : ""}`}
        >
          <div className="relative">
            {createCourseLoading && <Loader text={loadingText} />}
            <h2 className="!text-[#000000] !font-medium !text-[1.1rem]">
              {showUploadFile
                ? "Upload Files to your course"
                : "Create Course"}{" "}
            </h2>
            {showUploadFile ? (
              <UploadFiles
                isCreateCourse={true}
                handleSave={createCourse}
                goBack={gotToStepOne}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                selectedRepoFiles={selectedRepoFiles}
                setSelectedRepoFiles={setSelectedRepoFiles}
                setLoad={setCreateCourseLoading}
                setLoadingText={setLoadingText}
                closeModal={closeModal}
                links={links}
                setLinks={setLinks}
                makeLinkRow={makeLinkRow}
              />
            ) : (
              <>
                <div className="Create-Course-inner-input-container">
                  <div className="Create-Course-inner-input">
                    <div className="course-input-character-limit">
                      <label>Course Name</label>
                      <span style={{ fontSize: "10px" }}>
                        (Character limit: {courseFormState.name.length || 0}
                        /50)
                      </span>
                    </div>

                    <FormControl
                      margin="none"
                      fullWidth
                      error={!!formErrors.name}
                    >
                      <TextField
                        name="name"
                        placeholder="Eg. SQL"
                        className="edit-course-input-fields"
                        variant="outlined"
                        size="small"
                        value={courseFormState.name}
                        error={!!formErrors.name}
                        helperText={formErrors.name || ""}
                        onChange={handleInputChange}
                        InputProps={{
                          sx: {
                            borderRadius: "6px",
                            backgroundColor: "#FFFFFF",
                            padding: "0px",
                            height: "36px",
                          },
                          inputProps: { maxLength: 50 },
                        }}
                      />
                      {/* <FormHelperText> {formErrors.name || " "}</FormHelperText> */}
                    </FormControl>
                  </div>
                  <div className="Create-Course-inner-input ">
                    <label>Subject</label>
                    <FormControl
                      margin="none"
                      fullWidth
                      error={!!formErrors.subject}
                    >
                      <Autocomplete
                        value={
                          subjectsArray.find(
                            (option) => option.key === courseFormState.subject,
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const value = newValue ? newValue.key : "";
                          setCourseFormState((prev) => ({
                            ...prev,
                            subject: value,
                          }));
                        }}
                        id="subjects-autocomplete"
                        options={capitalizedOptions}
                        getOptionLabel={(option) =>
                          option.value
                            ? capitalizeFirstLetter(option.value)
                            : ""
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="subject"
                            className="edit-course-input-fields"
                            placeholder="E.g., SQL"
                            variant="outlined"
                            size="small"
                            error={!!formErrors.subject}
                            helperText={formErrors.subject || ""}
                            InputProps={{
                              ...params.InputProps,
                              value:
                                params.InputProps.value &&
                                capitalizeFirstLetter(params.InputProps.value),
                              sx: {
                                borderRadius: "6px",
                                backgroundColor: "#FFFFFF",
                                textTransform: "capitalize",
                              },
                            }}
                          />
                        )}
                        sx={{
                          "& .MuiAutocomplete-listbox": {
                            textTransform: "capitalize",
                          },
                          /*  "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
          paddingBottom: "11px", // Added inline padding-bottom
        }, */
                        }}
                      />
                    </FormControl>
                  </div>
                  <div className="create-course-Grade-input-folder">
                    <div className="Create-Course-inner-input create-course-inner-input-grade">
                      <label>Level</label>
                      <FormControl
                        margin="none"
                        fullWidth
                        error={!!formErrors.from_grade}
                      >
                        <Autocomplete
                          value={
                            gradeArray.find(
                              (option) =>
                                option.key === courseFormState.from_grade,
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            const value = newValue ? newValue.key : "";
                            setCourseFormState((prev) => ({
                              ...prev,
                              from_grade: value,
                            }));
                            setLevelInputValue(newValue ? newValue.value : "");
                          }}
                          inputValue={levelInputValue}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input")
                              setLevelInputValue(newInputValue);
                            else if (reason === "clear") setLevelInputValue(""); // Clear the input value when the clear action is triggered
                          }}
                          id="from-grade-autocomplete"
                          // Once a To Level is picked, only allow grades up to it
                          options={
                            courseFormState.to_grade
                              ? gradeArray.filter(
                                  (option) =>
                                    Number(option.key) <=
                                    Number(courseFormState.to_grade),
                                )
                              : gradeArray
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.key === value.key
                          }
                          getOptionLabel={(option) => option.value || ""}
                          renderInput={(params) => (
                            <TextField // Using TextField directly for simplicity; replace with FilteredTextField if necessary
                              {...params}
                              name="from_grade"
                              className="edit-course-input-fields"
                              placeholder="E.g., 9"
                              variant="outlined"
                              size="small"
                              error={!!formErrors.from_grade}
                              helperText={formErrors.from_grade || ""}
                              InputProps={{
                                ...params.InputProps,
                                sx: {
                                  borderRadius: "6px",
                                  backgroundColor: "#FFFFFF",
                                },
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-listbox": {
                              textTransform: "capitalize",
                            },
                          }}
                        />
                      </FormControl>
                    </div>
                    <div className="Create-Course-inner-input create-course-inner-input-grade">
                      <label>To Level</label>
                      <FormControl
                        margin="none"
                        fullWidth
                        error={!!formErrors.to_grade}
                      >
                        <Autocomplete
                          value={
                            // This should be the object that is currently selected or null if nothing is selected
                            gradeArray.find(
                              (option) =>
                                option.key === courseFormState.to_grade,
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            const value = newValue ? newValue.key : "";
                            setCourseFormState((prev) => ({
                              ...prev,
                              to_grade: value,
                            }));
                            // This will clear the input allowing for a new value to be typed in
                            setToLevelInputValue(
                              newValue ? newValue.value : "",
                            );
                          }}
                          inputValue={toLevelInputValue}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              // Update the inputValue state only when the user is typing
                              setToLevelInputValue(newInputValue);
                            } else if (reason === "clear") {
                              // Clear the input value when the clear action is triggered or after a selection is made
                              setToLevelInputValue("");
                            }
                          }}
                          id="to-grade-autocomplete"
                          options={gradeArray.filter(
                            (option) =>
                              Number(option.key) >=
                              Number(courseFormState.from_grade),
                          )}
                          getOptionLabel={(option) => option.value || ""}
                          isOptionEqualToValue={(option, value) =>
                            option.key === value.key
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="to_grade"
                              className="edit-course-input-fields"
                              placeholder="E.g., 12"
                              variant="outlined"
                              size="small"
                              error={!!formErrors.to_grade}
                              helperText={formErrors.to_grade || ""}
                              InputProps={{
                                ...params.InputProps,
                                sx: {
                                  borderRadius: "6px",
                                  backgroundColor: "#FFFFFF",
                                },
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-listbox": {
                              textTransform: "capitalize",
                            },
                          }}
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div
                    className="Create-Course-inner-input"
                    id="courseStartDate"
                  >
                    <label>Course Start Date</label>
                    <FormControl margin="none" fullWidth>
                      <DesktopDatePicker
                        name="start_date"
                        className="edit-course-input-fields"
                        variant="outlined"
                        disablePast
                        value={
                          courseFormState.start_date
                            ? dayjs(courseFormState.start_date)
                            : null
                        }
                        onChange={(date) =>
                          handleInputChangedate("start_date", date)
                        }
                        slots={{ openPickerIcon: CalendarMonthIcon }}
                        open={open1}
                        onClose={() => setopen1(false)}
                        onOpen={() => setopen1(true)}
                        slotProps={{
                          field: { setopen1 },
                          inputAdornment: {
                            position: "start",
                          },
                          textField: {
                            onClick: () => setopen1(true),
                            size: "small",
                            error: !!formErrors.start_date,
                            helperText: formErrors.start_date || "",
                            InputProps: {
                              sx: {
                                borderRadius: "6px",
                                backgroundColor: "#FFFFFF",
                              },
                            },
                          },
                        }}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="Create-Course-inner-input create-course-end-date"
                    id="courseDate"
                  >
                    <label>
                      Course End Date <span>(Optional)</span>
                    </label>
                    {courseFormState.end_date && (
                      <i
                        onClick={() => resetEndDate()}
                        className="fa-solid fa-x"
                      ></i>
                    )}
                    <FormControl margin="none" fullWidth>
                      <DesktopDatePicker
                        name="end_date"
                        className="edit-course-input-fields"
                        disablePast
                        minDate={dayjs(courseFormState?.start_date ?? "")?.add(
                          1,
                          "day",
                        )}
                        value={
                          courseFormState.end_date
                            ? dayjs(courseFormState.end_date)
                            : null
                        }
                        onChange={(date) =>
                          handleInputChangedate("end_date", date)
                        }
                        slots={{ openPickerIcon: CalendarMonthIcon }}
                        open={open2}
                        onOpen={() => setopen2(true)}
                        onClose={() => setopen2(false)}
                        renderInput={(params) => {
                          return <TextField {...params} />;
                        }}
                        slotProps={{
                          field: { setopen2 },
                          inputAdornment: {
                            position: "start",
                          },
                          textField: {
                            onClick: () => setopen2(true),
                            size: "small",
                            InputProps: {
                              sx: {
                                borderRadius: "6px",
                                backgroundColor: "#FFFFFF",
                              },
                            },
                          },
                        }}
                      />
                    </FormControl>
                  </div>
                  {/* Marketplace: Monetize Course toggle */}
                  {globalState.enabled_modules?.includes("marketplace") &&
                    !globalState.subdomain_exists && (
                      <>
                        <div className="create-course-Grade-input-folder">
                          <div
                            className="Create-Course-inner-input create-course-inner-input-grade create-course-monetize-toggle"
                            id="courseMonetize"
                          >
                            <div className="restriction-iocn">
                              <label>Monetize Course</label>
                              <img
                                src={restrichtion_icon}
                                data-tooltip-id="monetize-course"
                                style={{ fontSize: "6px" }}
                              />
                            </div>

                            <FormControl margin="none">
                              <TextField
                                value={isMonetizeEnabled ? "On" : "Off"}
                                size="small"
                                style={{ width: "145px" }}
                                InputProps={{
                                  readOnly: true,
                                  endAdornment: (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={isMonetizeEnabled}
                                          onChange={handleSwitchToggle}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  ),
                                  sx: {
                                    borderRadius: "6px",
                                    backgroundColor: "#fff",
                                  },
                                }}
                              />
                            </FormControl>

                            <Tooltip
                              id="monetize-course"
                              place="top"
                              content="Enable this toggle to display course monetization options."
                              type="light"
                              effect="float"
                            />
                          </div>
                          {isMonetizeEnabled && isValidDomain && globalState.enabled_modules?.includes("toggle_button") && (
                          <div className="Create-Course-inner-input create-course-inner-input-grade domain-field-column"  id="courseMonetize"
>
                            <label id="courseDate">Free for specific domain</label>

                            <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
                              <div className="domain-dropdown">
                                <TextField
                                  name="free_domains"
                                  className="edit-course-input-fields domain-select-field"
                                  placeholder=" Select Domain"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={selectedDomains.join(", ")}
                                  onClick={() => setShowDropdown((prev) => !prev)}


                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <ArrowDropDownIcon
                                        className={`domain-dropdown-arrow ${showDropdown ? "open" : ""}`}
                                        sx={{ color: "rgba(0, 0, 0, 0.54)" }}
                                      />
                                    ),
                                    sx: {
                                      borderRadius: "6px",
                                      backgroundColor: "#FFFFFF",
                                      cursor: "pointer",
                                    },
                                  }}
                                />


                                {showDropdown && (
                                  <div className="domain-checkbox-container">
                                    {/* Select All */}

                                    <div className="checkbox-row">
                                      <input
                                        type="checkbox"
                                        id="select-all"
                                        checked={
                                          freedomain.length > 0 &&
                                          selectedDomains.length === freedomain.length
                                        }
                                        onChange={handleSelectAll}
                                      />
                                      <label htmlFor="select-all">Select All</label>
                                    </div>

                                    <hr />

                                    {freedomain.map((domain) => (
                                      <div className="checkbox-row" key={domain}>
                                        <input
                                          type="checkbox"
                                          id={domain}
                                          checked={selectedDomains.includes(domain)}
                                          onChange={() => handleCheckboxChange(domain)}
                                        />
                                        <label htmlFor={domain}>{domain}</label>
                                      </div>
                                    ))}
                                  </div>
                                )}

                              </div>
                            </ClickAwayListener>

                              </div>
                                                            )}
                        </div>
                      </>
                    )}
                </div>
                {/* Marketplace: Monetize Course pricing section */}
                {globalState.enabled_modules?.includes("marketplace") &&
                  isMonetizeEnabled &&
                  !globalState.subdomain_exists && (
                    <div className="Create-Course-disscount-wrapper">
                      <div
                        className="Create-Course-inner-input"
                        id="Create-Course-Price"
                      >
                        <label>Course Price ({currency_symbol ?? ""})</label>
                        <FormControl
                          margin="none"
                          required
                          fullWidth
                          error={!!formErrors.price}
                        >
                          <TextField
                            type="number"
                            name="price"
                            className="edit-course-input-fields"
                            placeholder={`E.g. ${currency_symbol ?? ""}100`}
                            variant="outlined"
                            size="small"
                            value={courseFormState.price}
                            error={!!formErrors.price}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              const value = e.target.value;
                              // Allow only up to 2 decimal places
                              if (value.includes(".")) {
                                const parts = value.split(".");
                                if (parts[1]?.length > 2) {
                                  e.target.value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                }
                              }
                            }}
                            InputProps={{
                              startAdornment: (
                                <span
                                  style={{
                                    marginLeft: "12px",
                                    color: "#1A1A1A",
                                  }}
                                >
                                  {currency_symbol ?? ""}
                                </span>
                              ),
                              sx: {
                                borderRadius: "6px",
                                backgroundColor: "#FFFFFF",
                                padding: "0px",
                              },

                              inputProps: {
                                min: 0,
                                step: 1,    // ← allows whole numbers only
                              },
                            }}
                          />
                          <FormHelperText>{formErrors.price}</FormHelperText>
                        </FormControl>
                      </div>
                      <div
                        className="Create-Course-inner-input"
                        id="courseMonetize"
                        data-tooltip-id={currency_symbol === "$" &&
                          Number(courseFormState.price) === 1 ? "course-discount-price" : null}
                      >
                        <label>Course Discount %</label>
                        <FormControl
                          margin="none"
                          id="course-discount"

                          required
                          fullWidth
                          error={!!formErrors.discount_percentage}
                        >
                          <Autocomplete
                            disabled={
                              currency_symbol === "$" &&
                              Number(courseFormState.price) === 1
                            }
                            value={
                              courseFormState.discount_percentage
                                ? `${courseFormState.discount_percentage}%`
                                : null
                            }
                            onChange={(event, newValue) => {
                              // Update the form state with the selected discount percentage
                              const numericValue = newValue
                                ? String(newValue).replace("%", "")
                                : "";
                              handleInputChange({
                                target: {
                                  name: "discount_percentage",
                                  value: numericValue, // Assuming newValue is the selected discount percentage
                                },
                              });
                            }}
                            id="discount_percentage"
                            options={transformedDiscountArr}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="discount_percentage"
                                className="edit-course-input-fields"
                                placeholder="E.g. 5%"
                                variant="outlined"
                                size="small"
                                error={!!formErrors.discount_percentage}
                                helperText={formErrors.discount_percentage}
                                InputProps={{
                                  ...params.InputProps,
                                  // value: params.InputProps.value ? capitalizeFirstLetter(params.InputProps.value) : "",
                                  sx: {
                                    borderRadius: "6px",
                                    backgroundColor: "#FFFFFF",
                                    textTransform: "capitalize",
                                    marginBottom: "35px",
                                    height: "39px",
                                  },
                                }}
                                disabled={
                                  currency_symbol === "$" &&
                                  Number(courseFormState.price) === 1
                                }
                              />
                            )}
                            sx={{
                              "& .MuiAutocomplete-listbox": {
                                textTransform: "capitalize",
                              },
                            }}
                          />

                        </FormControl>
                        <Tooltip
                          id="course-discount-price"
                          place="top"
                          content="Discounts are not applicable for $1 course."
                          type="light"
                          effect="float"
                          style={{
                            maxWidth: "250px",
                            marginBottom: "5px",
                          }}
                        />
                      </div>
                      <Tooltip
                        id="course-discount"
                        place="top"
                        content={
                          currency_symbol === "$" && Number(courseFormState.price) === 1
                            ? "Discount is not available for a $1 course."
                            : ""
                        } type="light"
                        effect="float"
                      />
                      <div
                        className="Create-Course-inner-input relative"
                        id="courseMonetize"
                      >
                        <div>
                          <div className="restriction-iocn" style={{ display: "flex" }}>
                            <label>
                              Price After Discount ({currency_symbol ?? ""})
                            </label>
                            <img
                              src={restrichtion_icon}
                              data-tooltip-id="discount-price"
                            />
                          </div>
                          {/* <span className="course-discount-input">
                            <p>
                              {" "}
                              {currency_symbol ?? ""} {discountedAmt}
                            </p>
                            {currency_symbol === "$" && Number(roundOffValue) !== 0 && (
                              <small style={{ display: "block", color: "#666" }}>
                                {currency_symbol}
                                {actualDiscountAmt.toFixed(2)}
                                {" "}
                                {Number(roundOffValue) > 0 ? "+" : "-"}
                                {currency_symbol}
                                {Math.abs(Number(roundOffValue)).toFixed(2)}
                                {" = "}
                                {currency_symbol}
                                {discountedAmt}
                              </small>
                            )}
                          </span> */}
                          <span className="course-discount-input">
                            <p>
                              {currency_symbol} {discountedAmt}

                              { Number(roundOffValue) !== 0 && (
                                <span style={{ color: "#666", fontSize: "12px", marginLeft: "8px" }}>
                                  = {currency_symbol}
                                  {actualDiscountAmt.toFixed(2)}
                                  {" "}
                                  {Number(roundOffValue) > 0 ? "+" : "-"}
                                  {" "}
                                  {currency_symbol}
                                  {Math.abs(Number(roundOffValue)).toFixed(2)} (rounded off value)
                                </span>
                              )}
                            </p>
                          </span>
                        </div>

                        <div
                          className="absolute text-[11px]"
                          style={{ bottom: "-34px" }}
                        >
                          {courseFormState.price &&
                            formErrors.discounted_price && (
                              <FormHelperText error className="!text-[11px]">
                                {formErrors.discounted_price}
                              </FormHelperText>
                            )}
                        </div>
                        <Tooltip
                          id="discount-price"
                          place="top"
                          content={
                            <>
                              Course Price after discount will be{" "}
                              <span style={{ textDecoration: "line-through" }}>
                                {currency_symbol ?? ""}
                                {courseFormState.price
                                  ? courseFormState.price
                                  : 0}
                              </span>{" "}
                              {currency_symbol ?? ""}
                              {discountedAmt ? discountedAmt : 0}
                            </>
                          }
                          type="light"
                          effect="float"
                          style={{ maxWidth: "250px" }}
                        />
                      </div>
                      <div
                        className="Create-Course-inner-input"
                        id="courseMonetize"
                      >
                        <div className="restriction-iocn">
                          <label>Platform Fee</label>
                          <img
                            src={restrichtion_icon}
                            data-tooltip-id="course-platform-fee"
                          />
                        </div>
                        <span className="course-discount-input">
                          <p>
                            {currency_symbol ?? ""} {commission}
                          </p>
                        </span>
                        <Tooltip
                          id="course-platform-fee"
                          place="top"
                          // content={`Our platform applies a ${platformfee?.percentage}% commission fee on course purchased.`}
                          content={`Note: ProSchool charges a ${platformfee}% commission per course sale to support platform enhancement and operation.`}
                          type="light"
                          effect="float"
                          style={{ maxWidth: "250px" }}
                        />
                      </div>
                      <div
                        className="Create-Course-inner-input"
                        id="courseMonetize"
                      >
                        <div className="restriction-iocn">
                          <label>What you get</label>
                          <img
                            src={restrichtion_icon}
                            data-tooltip-id="course-What-you-get"
                          />
                        </div>
                        <span className="course-discount-input">
                          <p>
                            {currency_symbol ?? ""} {finalAmt}
                          </p>
                        </span>
                        <Tooltip
                          id="course-What-you-get"
                          place="top"
                          // content="Taxes & applicable fees shall be deducted depending on local taxes."
                          content="Note: Taxes and additional fees will be subtracted from the final payout amount."
                          type="light"
                          effect="float"
                          style={{ maxWidth: "250px" }}
                        />
                      </div>
                    </div>
                  )}
                <div className="Create-Course-des-wrapper">
                  <div className="Create-Course-des-folder">
                    <div className="Create-Course-des-title">
                      <label>Course description</label>
                      <span>
                        (Character limit:{" "}
                        {courseFormState.description.length || 0}/1000)
                      </span>
                    </div>
                    <FormControl
                      margin="none"
                      fullWidth
                      error={!!formErrors.description}
                    >
                      <TextField
                        id="create-course-description"
                        name="description"
                        multiline
                        variant="outlined"
                        size="small"
                        margin="normal"
                        cols="30"
                        minRows={7}
                        value={courseFormState.description || ""}
                        placeholder="Enter a short description about your course "
                        error={!!formErrors.description}
                        onChange={handleInputChange}
                        InputProps={{
                          sx: {
                            borderRadius: "12px",
                            backgroundColor: "#F5F5F5",
                          },
                        }}
                        inputProps={{
                          maxLength: 1000, // Set the maximum length of the input
                        }}
                      />
                      <FormHelperText>{formErrors.description}</FormHelperText>
                    </FormControl>
                    {loading ? <Waveform /> : <></>}
                    <div className="create-course-enhance-course-folder tab-hidden">
                      <div className="Course-description-inner-ai-feilds-folder">
                        <EnhancedDescription
                          courseName={courseFormState.name || ""}
                          subject={courseFormState.subject || ""}
                          from_grade={courseFormState.from_grade || ""}
                          to_grade={courseFormState.to_grade || ""}
                          keywords={courseFormState.description || ""}
                          error={!!formErrors.description}
                        />
                      </div>
                      <div className="Create-Course-btn-wrapper">
                        <button
                          type="button"
                          className="Create-Course-cancle-btn"
                          onClick={handleCancelClick}
                          data-aos="zoom-out"
                        >
                          Cancel
                        </button>

                        <button
                          type="submit"
                          disabled={
                            createLoading ||
                            // Object.values(formErrors).some(
                            //   (error) => error,
                            // ) ||
                            hasBlockingErrors ||
                            (isMonetizeEnabled && !courseFormState.price)
                          }
                          className="Create-Courses-btn"
                        >
                          {/* Create Course */}
                          {isLowerSchoolEnabled && +courseFormState?.to_grade <= 5 ? "Submit" : "Next"}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="uploded-image-section">
                    <FormControl
                      margin="none"
                      fullWidth
                      error={!!formErrors.image}
                    >
                      <div className="Create-Course-image">
                        <div className="Create-Course-image-disclamer">
                          <p>Course Image</p>
                          <span>
                            (Heads Up: Our Image Generator is in Beta and Might
                            Have Its Quirks!)
                          </span>
                        </div>
                        {uplodedImage ? (
                          <>
                            <div className="course-main-image text-center">
                              <ReactSVG
                                className="course-image-close"
                                src={close}
                                onClick={() => {
                                  setCourseFormState((prev) => ({
                                    ...prev,
                                    image: "",
                                    image_url: "",
                                  }));
                                  setSelectedImage(null);
                                  setUplodedImage(null);
                                  setImageUploaded(false);
                                  setChangeImageUploadText(false);
                                }}
                              />
                              <img
                                className="course-uploded-image"
                                src={
                                  imageUploaded ? selectedImage : uplodedImage
                                }
                                alt=""
                              />
                            </div>
                          </>
                        ) : (
                          <div
                            className="course-file-image"
                            style={
                              !!formErrors.image
                                ? { border: "2px #d32f2f dashed" }
                                : null
                            }
                          />
                        )}

                        <div className="Create-Course-uplode-image-container">
                          {!uplodedImage && (
                            <>
                              <div className="Create-Course-uisng-ai">
                                {isRegenerate && (
                                  <img
                                    className={`loding ${
                                      isRegenerate ? "spinning" : ""
                                      }`}
                                    src={autorenew}
                                    alt=""
                                  />
                                )}
                                <button
                                  type="button"
                                  onClick={generatesImges}
                                  className={`course-Generating-AI-btn`}
                                  disabled={
                                    !courseFormState.name ||
                                    !courseFormState.subject ||
                                    !courseFormState.description ||
                                    !courseFormState.from_grade ||
                                    !courseFormState.start_date ||
                                    isRegenerate ||
                                    errorMessage ===
                                    "The AI image generation has reached its three-attempt limit."
                                    // clickCount >= 3
                                  }
                                >
                                  Generate using AI
                                </button>
                              </div>
                              <div className="Create-Course-uisng-ai uplode-image">
                                <OutlineFIleInput
                                  label={"Upload Image"}
                                  handleFileInput={handleFileInput}
                                  disabled={isDescGenerating}
                                />
                                {imageUploading && (
                                  <img
                                    className={` ${
                                      imageUploading ? "spinning" : ""
                                      }`}
                                    src={autorenew}
                                    alt=""
                                  />
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {uplodedImage && (
                        <>
                          <div className="reuplode-image-folder">
                            <div
                              className="Create-Course-uplode-outer-image"
                              style={
                                isRegenerate
                                  ? { pointerEvents: "none", opacity: "0.5" }
                                  : {}
                              }
                            >
                              <OutlineFIleInput
                                label={
                                  changeImageUploadText
                                    ? "Re-Upload Image"
                                    : "Upload Image"
                                }
                                handleFileInput={(e) => {
                                  setSelectedImage(null);
                                  handleFileInput(e);
                                }}
                                disabled={isDescGenerating}
                              />
                            </div>
                            <div className="Regenerate-Course-image">
                              <img
                                className={`Regenerate-image ${
                                  isRegenerate ? "spinning" : ""
                                  }`}
                                src={autorenew}
                                alt=""
                              />
                              <button
                                disabled={
                                  !courseFormState.name ||
                                  !courseFormState.subject ||
                                  !courseFormState.description ||
                                  !courseFormState.from_grade ||
                                  !courseFormState.start_date ||
                                  isRegenerate ||
                                  errorMessage ===
                                  "The AI image generation has reached its three-attempt limit."
                                  // clickCount >= 3
                                }
                                onClick={generatesImges}
                                type="button"
                                className="Regenerate-course-btn"
                              >
                                {changeImageUploadText
                                  ? "Generate"
                                  : "Regenerate"}
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="limiterrorMessage">
                        {errorMessage && <span>{errorMessage}</span>}
                      </div>
                      <div
                        className="Create-Course-btn-wrapper"
                        id="Create-Course-cancle-btn-wrapper"
                      >
                        <button
                          type="button"
                          className="Create-Course-cancle-btn"
                          onClick={handleCancelClick}
                          data-aos="zoom-out"
                        >
                          Cancel
                        </button>

                        <button
                          type="submit"
                          disabled={
                            createLoading || hasBlockingErrors
                            // Object.values(formErrors).some((error) => error)
                          }
                          className="Create-Courses-btn"
                        >
                          {/* Create Course */}
                          {isLowerSchoolEnabled && +courseFormState?.to_grade <= 5 ? "Submit" : "Next"}
                        </button>
                      </div>
                      <FormHelperText>{formErrors.image}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
              </>
            )}
          </div>
          {!showUploadFile && (
          <div className="create-course-enhance-course-folder tab-display">
                      <div className="Course-description-inner-ai-feilds-folder">
                        <EnhancedDescription
                          courseName={courseFormState.name || ""}
                          subject={courseFormState.subject || ""}
                          from_grade={courseFormState.from_grade || ""}
                          to_grade={courseFormState.to_grade || ""}
                          keywords={courseFormState.description || ""}
                          error={!!formErrors.description}
                        />
                      </div>
                      <div className="Create-Course-btn-wrapper">
                        <button
                          type="button"
                          className="Create-Course-cancle-btn"
                          onClick={handleCancelClick}
                          data-aos="zoom-out"
                        >
                          Cancel
                        </button>

                        <button
                          type="submit"
                          disabled={
                            createLoading ||
                            // Object.values(formErrors).some(
                            //   (error) => error,
                            // ) ||
                            hasBlockingErrors ||
                            (isMonetizeEnabled && !courseFormState.price)
                          }
                          className="Create-Courses-btn"
                        >
                          {/* Create Course */}
                          {isLowerSchoolEnabled && +courseFormState?.to_grade <= 5 ? "Submit" : "Next"}
                        </button>
                      </div>
                    </div>)}
        </div>
      </form>
      {/* {isShowGoogleUploadPopup && (
        <GoogleUploadPopup
          setSelectedFiles={setSelectedFiles}
          selectedFiles={selectedFiles}
          setIsShowGoogleUploadPopup={setIsShowGoogleUploadPopup}
          isShowGoogleUploadPopup={isShowGoogleUploadPopup}
        />
      )} */}

      {isDeletePopupOpen && (
        <DeletePopup
          title="Are you sure you want to add this subject"
          cancel="Back"
          submit="Submit"
          onclick={handleAddSubjects}
          onClose={handleClose} // Pass handleClose as a prop
        />
      )}

      {openDialog && (
        <div className="Course-created-successfully-main">
          <div className="Course-created-successfully-container">
            <div className="Course-created-successfully-folder">
              <h2>Are you sure you want to cancel your course creation?</h2>
              <div className="Course-close-btn">
                <button type="submit" onClick={cancelRegistration}>
                  No
                </button>
                <button
                  type="submit"
                  onClick={confirmCancellation}
                  className="Course-close"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCoursesuccesfully && (
        <div className="Course-created-successfully-main">
          <div className="Course-created-successfully-container">
            <div className="Course-created-successfully-folder">
              <div className="Course-created-successfully-image">
                <img src={Course_created_successfully_image} alt="" />
              </div>
              <h2>Course created successfully</h2>
            </div>
          </div>
        </div>
      )}

      {createLoading && <LodingAnimation />}

      {modalIsOpen && (
        <CropProfileImageModal
          src={selectedImage}
          setSrc={setSelectedImage}
          setSelectedImage={setSelectedImage}
          setImageUploaded={setImageUploaded}
          setUplodedImage={setUplodedImage}
          modalStatus={modalIsOpen}
          setModalClose={onCloseModal}
          fieldName={"image"}
          setFormState={setCourseFormState}
          formState={courseFormState}
          aspectRatio={16 / 9}
        />
      )}

      {isAddToSubjetModelOpen && (
        <EditSubject
          subject_title="Add the subjects you teach"
          modalStatus={isAddToSubjetModelOpen}
          subjectlist={Object.values(
            isTeacher
              ? Object.values(globalState.teacher_details?.data?.subjects)
              : Object.values(globalState.student_details?.data?.interest),
          )}
          setModalClose={() => {
            setIsAddToSubjetModelOpen(false);
            setCourseFormState((prev) => ({
              ...prev,
              subject: "",
            }));
          }}
          onClose={() => {
            setIsAddToSubjetModelOpen(false);
            setCourseFormState((prev) => ({
              ...prev,
              subject: "",
            }));
          }}
          onSubmit={(subjects) => {
            setaddNewSubjects(subjects?.join(","));
            setIsDeletePopupOpen(true);
            setCourseFormState((prev) => ({
              ...prev,
              subject: "",
            }));
          }}
        />
      )}
    </>
  );
};

export default CreateCourse;